import axios from '@axios'

export default {
  namespaced: true,
  state:()=> ({
    root:null,
    loadings:0,
    list:[],
    rowsFrom:0,
    rowsTo:0,
    rowsTotal:0,
    perPage:10,
    currentPage:1,
    device_id:null,
    searchQuery:null,
    categoriesFilter:null,
    categoriesOptions:[],
    ownersFilter:null,
    ownersOptions:[],
    typesFilter:null,
    typesOptions:[],
    contractsFilter:null,
    contractsOptions:[],
    isSupportFilter:'all'
  }),
  mutations:{
    updateRoot(state, payload){
      state.root = payload
    },
    startLoadingState(state){
      state.loadings += 1
    },
    stopLoadingState(state){
      state.loadings -= 1
    },
    updateList(state, payload){
      state.list = payload
    },
    updateRowsFrom(state, payload){
      state.rowsFrom = payload
    },
    updateRowsTo(state, payload){
      state.rowsTo = payload
    },
    updateRowsTotal(state, payload){
      state.rowsTotal = payload
    },
    updatePerPage(state, payload){
      state.perPage = payload.value
    },
    updateCurrentPage(state, payload){
      state.currentPage = payload.value
    },
    updateDeviceId(state, payload){
      state.device_id = payload
    },
    updateSearchQuery(state, payload){
      state.searchQuery = payload.value
    },
    updateCategoriesFilter(state, payload){
      state.categoriesFilter = payload.value
    },
    updateCategoriesOptions(state, payload){
      state.categoriesOptions = payload
    },
    updateOwnersFilter(state, payload){
      state.ownersFilter = payload.value
    },
    updateOwnersOptions(state, payload){
      state.ownersOptions = payload
    },
    updateTypesFilter(state, payload){
      state.typesFilter = payload.value
    },
    updateTypesOptions(state, payload){
      state.typesOptions = payload
    },    
    updateContractsFilter(state, payload){
      state.contractsFilter = payload.value
    },
    updateContractsOptions(state, payload){
      state.contractsOptions = payload
    },
    updateIsSupportFilter(state, payload){
      state.isSupportFilter = payload.value
    }
  },
  actions: {
    fetchFiltersOptions({ commit }){
      commit('startLoadingState')
      axios.get('filters/getFilterBy', { params:{
        type: 'device',
        hasMaintenances:true
      }})
      .then(r => {
          commit('updateCategoriesOptions', r.data.data.categories)
          commit('updateOwnersOptions', r.data.data.owners)
          commit('updateTypesOptions', r.data.data.types)
          commit('updateContractsOptions', r.data.data.contracts)
          commit('stopLoadingState')
      })
      .catch(error => {})
    },
    fetchList({ commit, getters }){
      commit('startLoadingState')
      axios.get('maintenances', { params:{
        length: getters.perPage,
        page: getters.currentPage,
        ...(getters.isUsingDeviceIdFilter && {device: getters.device_id}),
        ...(getters.isUsingSearchQueryFilter && {q: getters.searchQuery}),
        ...(getters.isUsingCategoriesFilter && {categories: getters.categoriesFilter}),
        ...(getters.isUsingOwnersFilter && {owners: getters.ownersFilter}),
        ...(getters.isUsingTypesFilter && {types: getters.typesFilter}),
        ...(getters.isUsingContractsFilter && {contracts: getters.contractsFilter}),
        ...(getters.isUsingIsSupportFilter && {isSupport: getters.isSupportFilter}),

      }})
      .then(r => {
          commit('updateList', r.data.data.data)
          commit('updateRowsFrom', r.data.data.meta.from)
          commit('updateRowsTo', r.data.data.meta.to)
          commit('updateRowsTotal', r.data.data.meta.total)
          commit('stopLoadingState')
      })
      .catch(error => {})
    },
    export({ commit, getters }, payload ){
      commit('startLoadingState')
      axios.post('export', {
            export: 'maintenancesList',
            exporter: payload.type,
        ...(getters.isUsingDeviceIdFilter && {device: getters.device_id}),
        ...(getters.isUsingSearchQueryFilter && {q: getters.searchQuery}),
      }, { responseType: 'blob' })
      .then(response => {

          const type = response.headers['content-type']
          const blob = new Blob([response.data], { type, encoding: 'UTF-8' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `maintenances.${payload.type}`
          link.click()

          commit('stopLoadingState')

      })
      .catch(error => {})
    },
    exportPDF({ dispatch }){
      dispatch('export' , { type:'pdf' })
    },
    exportXLSX({ dispatch }){
      dispatch('export' , { type:'xlsx' })
    },
    done({ commit, getters, dispatch }, payload){
      getters.root.$swal({
        icon:'warning',
        title: getters.root.$i18n.t("SWAL_CONFIRM_BOX_TITLE"),
        text: getters.root.$i18n.t('MAINTENANCES_DONE_CONFIRMATION'),
        showCancelButton: true,
        confirmButtonText: getters.root.$i18n.t('SWAL_CONTINUE_BUTTON_LABEL'),
        cancelButtonText: getters.root.$i18n.t('SWAL_CANCEL_BUTTON_LABEL'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( confirmBox => {
        if (confirmBox.isConfirmed) {
          getters.root.$swal({
            icon:'question',
            title: getters.root.$i18n.t("MAINTENANCES_DONE_NEW_LIMIT_TITLE"),
            showCancelButton: true,
            input: 'text',
            inputLabel: '\n',
            inputValue: payload.limit,
            confirmButtonText: getters.root.$i18n.t('SWAL_SUBMIT_BUTTON_LABEL'),
            cancelButtonText: getters.root.$i18n.t('SWAL_CANCEL_BUTTON_LABEL'),
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          })
          .then( newLimitBox => {
            if(newLimitBox.isConfirmed){
              commit('startLoadingState')
              axios.put(`maintenances/${payload.id}/done` , {
                limit:newLimitBox.value
              })
              .then( response => {
                  commit('stopLoadingState')
                  getters.root.$bvToast.toast(
                    getters.root.$i18n.t('MAINTENANCES_UPDATE_SUCCESS_MESSAGE'), {
                    variant: 'success',
                    solid: true,
                  })
                  dispatch('fetchList')
                }).catch( reason => {
                  commit('stopLoadingState')
                  let message = getters.root.$i18n.t('MAINTENANCES_UPDATE_FAILURE_MESSAGE')
                  if(reason.response.status === 422){
                    message = getters.root.$i18n.t(Object.values(reason.response.data.errors).flat()[0])
                  }
                  getters.root.$swal({
                    icon:'error',
                    title: getters.root.$i18n.t("SWAL_ERROR_BOX_TITLE"),
                    text: message,
                    confirmButtonText: getters.root.$i18n.t('SWAL_OK_BUTTON_LABEL'),
                    customClass: {
                      confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                  })
                })
            }
          })
        }
      })
    },
    delete({ commit, getters, dispatch }, payload){
      getters.root.$swal({
        icon:'warning',
        title: getters.root.$i18n.t("SWAL_CONFIRM_BOX_TITLE"),
        text: getters.root.$i18n.t('MAINTENANCES_DELETE_CONFIRMATION'),
        showCancelButton: true,
        confirmButtonText: getters.root.$i18n.t('SWAL_YES_BUTTON_LABEL'),
        cancelButtonText: getters.root.$i18n.t('SWAL_CANCEL_BUTTON_LABEL'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( confirmBox => {
        if ( confirmBox.isConfirmed) {
          commit('startLoadingState')
          axios.delete(`maintenances/${payload.id}`)
          .then( response => {
              commit('stopLoadingState')
              getters.root.$bvToast.toast(
                getters.root.$i18n.t('MAINTENANCES_DELETE_SUCCESS_MESSAGE'), {
                variant: 'success',
                solid: true,
              })
              dispatch('fetchList')
              dispatch('fetchFiltersOptions')
            }).catch( reason => {
              getters.root.$bvToast.toast(
                getters.root.$i18n.t('MAINTENANCES_DELETE_FAILURE_MESSAGE'), {
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    }
  },
  getters:{
    root(state){
      return state.root
    },
    isLoading(state){
      return state.loadings > 0
    },
    perPageOptions(){
      return [2,10,50,100,500]
    },
    perPage(state){
      return state.perPage
    },
    currentPage(state){
      return state.currentPage
    },
    device_id(state){
      return state.device_id
    },
    isUsingDeviceIdFilter(state){
      return state.device_id !== null
    },
    searchQuery(state){
      return state.searchQuery
    },
    isUsingSearchQueryFilter(state){
      return state.searchQuery !== null
    },
    categoriesFilter(state){
      return state.categoriesFilter
    },
    categoriesOptions(state, getters){
      return state.categoriesOptions.map(category => ({id:category, name:getters.root.$i18n.t(category)}))
    },
    isUsingCategoriesFilter(state){
      return state.categoriesFilter !== null
    },
    ownersFilter(state){
      return state.ownersFilter
    },
    ownersOptions(state){
      return state.ownersOptions
    },
    isUsingOwnersFilter(state){
      return state.ownersFilter !== null
    },
    typesFilter(state){
      return state.typesFilter
    },
    typesOptions(state){
      return state.typesOptions
    },    
    isUsingTypesFilter(state){
      return state.typesFilter !== null
    },
    contractsFilter(state){
      return state.contractsFilter
    },
    contractsOptions(state){
      return state.contractsOptions
    },
    isUsingContractsFilter(state){
      return state.contractsFilter !== null
    },
    isSupportFilter(state){
      return state.isSupportFilter
    },
    isSupportFilterOptions(state, getters){
      return [
        {
          id:'all',
          name:getters.root.$i18n.t('FILTERS_IS_SUPPORT_ALL_LABEL')
        },
        {
          id:'true',
          name:getters.root.$i18n.t('FILTERS_IS_SUPPORT_TRUE_LABEL')
        },
        {
          id:'false',
          name:getters.root.$i18n.t('FILTERS_IS_SUPPORT_FALSE_LABEL')
        }
      ]
    },
    isUsingIsSupportFilter(state){
      return state.isSupportFilter !== 'all'
    },
    list(state){
      return state.list
    },
    tableMeta(state, getters){
      return `${ getters.root.$i18n.t('Showing') } ${ state.rowsFrom } to ${ state.rowsTo } of ${ state.rowsTotal } ${ getters.root.$i18n.t('entries') }`
    },
    tableTotalRows(state){
      return state.rowsTotal
    },
    tableColumns(state, getters){
      return [
        { 
          key: 'name',
          label: getters.root.$i18n.t('name'),
          sortable: true,
        },
        { 
          key: 'device',
          label: getters.root.$i18n.t('device'),
          sortable: true
        },
        { 
          key: 'category',
          label: getters.root.$i18n.t('category'),
          sortable: true,
          formatter: value =>  getters.root.$i18n.t(value)
        },
        { 
          key: 'owner',
          label: getters.root.$i18n.t('owner'),
          sortable: true
        },
        { 
          key: 'type',
          label: getters.root.$i18n.t('MAINTENANCES_TYPE_LABEL'),
          formatter: value => {
            
            switch(value){
              case 'distance': 
                  return getters.root.$i18n.t('MAINTENANCES_TYPE_DISTANCE_LABEL');
              case 'duration': 
                 return getters.root.$i18n.t('MAINTENANCES_TYPE_DURATION_LABEL');
            }
    
            return value;
          },
          sortable: true
        },
        { 
          key: 'limit',
          formatter: ( value, key, item ) => {
    
            let unit = null;
    
            switch(item.type){
              case 'duration' : 
                unit = getters.root.$i18n.t('MAINTENANCES_TYPE_DURATION_UNIT_LABEL');
                break;
              case 'distance' : 
                unit = getters.root.$i18n.t('MAINTENANCES_TYPE_DISTANCE_UNIT_LABEL');
                break;
            }
    
            return `${value} ${unit}`;
    
          },
          label: getters.root.$i18n.t('MAINTENANCES_LIMIT_LABEL'),
          sortable: true
        },
        { 
          key: 'remaining',
          formatter: ( value, key, item ) => {
    
            if(value > 0){
    
              let unit = null;
    
              switch(item.type){
                case 'duration' : 
                  unit = getters.root.$i18n.t('MAINTENANCES_TYPE_DURATION_UNIT_LABEL');
                  break;
                case 'distance' : 
                  unit = getters.root.$i18n.t('MAINTENANCES_TYPE_DISTANCE_UNIT_LABEL');
                  break;
              }
      
              return `${value} ${unit}`;
    
            }else{
              return getters.root.$i18n.t('MAINTENANCES_MAINTENANCE_REQUIRED_MESSAGE')
            }
    
          },
          label: getters.root.$i18n.t('MAINTENANCES_REMAINING_LABEL'),
          sortable: true
        },
        { 
          key: 'actions',
          label: getters.root.$i18n.t('actions')
        }
      ]
    }
  }
}
